export function getLocalStorageItem<T extends keyof LocalStorageItems & string>(key: T) {
  if (typeof window === 'undefined') return undefined;

  const item = localStorage.getItem(key);
  if (item != null && item.length > 0) {
    return JSON.parse(item) as LocalStorageItems[T];
  }
}
